'use client';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { FOLLOWERS_QUERY_KEY, FOLLOWING_QUERY_KEY } from '@/modules/players/v3/constants/following';
import { FRIENDS_TAB_COUNTS_QUERY_KEY } from '@/modules/players/v3/constants/friends';
import { RELATIONSHIP_QUERY_KEY } from '@/modules/players/v3/hooks/use-get-relationship';
import { unfollowUser } from '@/utils/actions/players/friends/unfollowUser';

export interface UseUnfollowParams {
  uuid: string;
  followedUuid: string;
}

export const useUnfollow = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ uuid, followedUuid }: UseUnfollowParams) => {
      const res = await unfollowUser({ uuid, followedUuid });
      if (res.error) {
        throw new Error(`Failed to unfollow: ${res.error}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FOLLOWING_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FOLLOWERS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [FRIENDS_TAB_COUNTS_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [RELATIONSHIP_QUERY_KEY] });
    },
  });
};
